import React from 'react'
import {largeImages,images} from './Landingpage.js'
import './final.css'


const Final = ({imgnum,setimage,setremove,remove}) => {

  const decideimage2 = (index) => {
    setimage(index); // Use setimage to update imgnum in App component
    const mins2 = document.getElementsByClassName('min2');
    for (let i = 0; i < images.length; i++) {
      mins2[i].querySelector('img').classList.remove('add');
      mins2[i].style.borderRadius = '5px';
      mins2[i].style.border = '';
    }

    const minsimg = mins2[index].querySelector('img');
    minsimg.classList.add('add');
    minsimg.style.border = '2px solid hsl(26, 100%, 55%)';
    minsimg.style.borderRadius = '5px';
  };


  const nextimage=()=>{
    if(imgnum!==3){
      setimage(prev=>prev+1);
    }
    else{
      setimage(3);
    }
  }
  const previmage=()=>{
    if(imgnum!==0){
      setimage(prev=>prev-1);
    }
    else{
      setimage(0);
    }
  }
  return (
    <div className='final'>
        <div className="into">
        <svg onClick={()=>setremove(false)} width="14" height="15" xmlns="http://www.w3.org/2000/svg"><path d="m11.596.782 2.122 2.122L9.12 7.499l4.597 4.597-2.122 2.122L7 9.62l-4.595 4.597-2.122-2.122L4.878 7.5.282 2.904 2.404.782l4.595 4.596L11.596.782Z" fill="#FFA500" fill-rule="evenodd"/></svg>
        </div>
        <div className="finalimage">
            <button id="nextimage" onClick={previmage}  className='prev'><svg width="12" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M11 1 3 9l8 8" stroke="#1D2026" stroke-width="3" fill="none" fill-rule="evenodd"/></svg></button>
            <img  src={largeImages[imgnum]}></img>
            <button id='previmage' onClick={nextimage} className='next'><svg width="13" height="18" xmlns="http://www.w3.org/2000/svg"><path d="m2 1 8 8-8 8" stroke="#1D2026" stroke-width="3" fill="none" fill-rule="evenodd"/></svg></button>

            
        </div>
        <div className="productminimage2">
          {images.map((img, index) => (
            <div className="min2" key={index}>
              <img 
                onMouseEnter={() => decideimage2(index)}
                src={img} 
                alt={`Thumbnail ${index + 1}`} 
              />
            </div>
          ))}
        </div>
      
    </div>
  )
}

export default Final

